export const blockIconsNotificationRunningWithErrors = (
	<span className='material-symbols-outlined'>running_with_errors</span>
);
